(() => {
  window.swinger.observer.initialize('swinger-widget--autocomplete', (elem) => {
    window.swinger.visibility.observe(elem, (visible) => {
      const list = elem.querySelector('.swinger-autocomplete[id]');

      if (!list) {
        return;
      }

      const owner = document.querySelector(`[aria-controls="${list.id}"]`);

      if (!owner) {
        return;
      }

      owner.setAttribute('aria-expanded', visible ? 'true' : 'false');
    });
  }, false);
})();
